'use strict';

angular.module('AcaApp').controller('UserManagementController', [
  '$scope',
  '$window',
  '$mdDialog',
  'UserService',
  'LayoutService',
  'UtilsService',
  'SecurityService',
  'EMAIL_MESSAGES',
  'PASSWORD_MESSAGES',
  'USERTYPE',
  'SettingsService',
  /* jscs:disable maximumLineLength */
  function($scope, $window, $mdDialog, UserService, LayoutService, UtilsService, SecurityService, EMAIL_MESSAGES, PASSWORD_MESSAGES, USERTYPE, SettingsService){
    $scope.currentUser = $window.sessionStorage.userName;
    $scope.newRealName = '';
    $scope.newPhone = '';
    $scope.showPasswordRequired = false;
    $scope.showPasswordRequired2 = false;
    $scope.newUser = {};
    $scope.data = {};
    $scope.showFirstNameRequiered = false;
    $scope.showLastNameNameRequiered = false;
    $scope.showEmailRequiered = false;
    $scope.showNewUser = false;
    $scope.specialCharsMsge = PASSWORD_MESSAGES.SPECIAL_CHARS;
    $scope.mfaChecked = '';
    
    $scope.isAdministrator = function(){
      if($window.sessionStorage.profile === 'CNV_ACAADMIN' || $window.sessionStorage.profile === 'CNV_ACASOVOS') {
        LayoutService.setBody('left-column-gray');
        return true;
      }
      LayoutService.setBody('gray-bg-no-admin');
      return false;
    };

    $scope.isMFAEnabled = function(){
      return ($window.sessionStorage.MFAEnabled === 'Y');
    };

    $scope.maskPhone = function(){
      var maskedPhone = '';
      if ($scope.user && $scope.user.PhoneNumber) {
        maskedPhone = 'XXX-XXX-' + $scope.user.PhoneNumber;
      }
      return maskedPhone;
    };

    $scope.deleteUserModal = function(event){
      $mdDialog.show({
        scope: $scope.$new(),
        templateUrl: 'app/views/userManagement/modals/delete_user.html',
        parent: angular.element(document.body),
        targetEvent: event
      });
    };

    $scope.deleteUser = function(){
      var userName = $scope.user.Username;
      UserService.deleteUser(userName).then(function(){
        $scope.listUsers();
        $mdDialog.hide();
      });
    };

    $scope.updateProfiles = function(){
      var userName = $scope.user.Username;
      var profilename = $scope.user.profileName;
      UserService.updateProfiles(userName, profilename).then(function(){
        $scope.listUsers();
        $scope.changeUserPage($scope.informationPage);
      });
    };

    $scope.updateUserRealName = function(data){
      var userName;
      if($scope.isAdministrator() && $scope.user.LiteUsername != $window.sessionStorage.userName){
        userName = $scope.user.Username;
      }
      else{
        userName = '';
      }
      $scope.user.RealName = data;
      var userRealname = $scope.user.RealName;
      UserService.updateUserRealName(userName, userRealname).then(function(){
        if($scope.isAdministrator()){
          $scope.listUsers();
        }
        else{
          $window.sessionStorage.realName = userRealname;
        }
        $scope.changeUserPage($scope.informationPage);
      });
    };

    $scope.validatePhone = function(phone) {
      return /^(\d{3})[-]?(\d{3})[-]?(\d{4})$/.test(phone);
    };

    $scope.updatePhone = function(newPhone){
      if($scope.validatePhone(newPhone)){
        UserService.updatePhone($scope.user.Username, '+1'+newPhone.replace(/-/g, ''), false).then(function(response){
          if(response.result.value){
            $window.sessionStorage.phoneNumber = newPhone.replace(/-/g, '').slice(-4);
            if($scope.isAdministrator()){
              $scope.listUsers();
            }
            else{
              $scope.user.PhoneNumber = newPhone.substring(newPhone.length -4);
            }
            $scope.changeUserPage($scope.informationPage);
          }else {
            $scope.errorMessage = 'There was an issue trying to save your phone number.';
          }
        });
      }
      else {
        $scope.errorMessage = 'Please enter a valid 10 digit phone number.';
      }
    };
    
    $scope.resetPhone = function(){
      UserService.updatePhone($scope.user.Username, '', false).then(function(){
        $scope.listUsers();
        $scope.closeModal();
      }, function(error){
        /* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
        $scope.errorMessage = (error.data.error.frontend_message || undefined);
      });
    };

    $scope.showModal = function(event, modal){
      $mdDialog.show({
        scope: $scope.$new(),
        templateUrl: modal,
        parent: angular.element(document.body),
        targetEvent: event
      });
    };

    $scope.resetPhoneModal = function(event){
      $scope.showModal(event, 'app/views/userManagement/modals/reset_phone.html');
    };

    $scope.resetPasswordModal = function(event){
      $scope.showModal(event, 'app/views/userManagement/modals/reset_password.html');
    };

    $scope.informationPage = 'information';
    $scope.editNamePage = 'editName';
    $scope.editPasswordPage = 'editPassword';
    $scope.editOptionsPage = 'editOptions';
    $scope.editPhonePage = 'editPhone';
    $scope.newUserPage = 'newUser';
    $scope.newUserSuccessfullyPage = 'newUserSuccessfully';
    $scope.multi_factor_auth = 'multi-factor-auth';

    $scope.listUsers = function(){
      UserService.getUsers().then(function(data){
        $scope.users = data.result;
        $scope.originalsUsers = angular.copy($scope.users);
        $scope.setDefaultUser();
      });
    };

    $scope.checkMfa = function(){
      SettingsService.getMfa().then(function(data){
        $scope.mfaChecked = data.result.value;
      }) 
    };
    
    $scope.updateMfa = function(mfa){
      SettingsService.updateMfa(mfa).then(function(data){
        if(data.result.value === 'updated'){
          $scope.mfaChecked = mfa;
          $window.sessionStorage.MFAEnabled = mfa;
        }
      });
    };

    $scope.setDefaultUser = function(){
      $scope.sortUserList();
      for(var i=0; i<$scope.users.length; i++) {
        if($scope.users[i].LiteUsername === $scope.currentUser){
          $scope.user = $scope.users[i];
          $scope.user.ProfileName = UserService.setProfile($scope.user.Profiles);
          break;
        }
      }
    };

    $scope.sortUserList = function(){
      $scope.users = _.sortBy($scope.users, 'RealName');
    };

    if($scope.isAdministrator()){
      $scope.listUsers();
    }
    else{
      $scope.user = {
        RealName: $window.sessionStorage.realName,
        LiteUsername: $window.sessionStorage.userName,
        Username: $window.sessionStorage.userId,
        PhoneNumber: $window.sessionStorage.phoneNumber
      };
    }
    var activeMenuButton = function(event){
      var activeClass = 'active';
      $('.menu li').removeClass(activeClass);
      $(event.target).attr('class', activeClass);
    };
    $scope.select = function(user, event){
      $scope.cancel();
      $scope.changeUserPage($scope.informationPage);
      activeMenuButton(event);
      $scope.user = user;
      $scope.user.ProfileName = UserService.setProfile(user.Profiles);
      $scope.showPasswordRequired = false;
    };
    $scope.edit = function(type){
      $scope.changeUserPage(type);
    };
    $scope.changeUserPage = function(type){
      switch(type){
        case 'name':
          $scope.userPage = $scope.editNamePage;
          $scope.newRealName = $scope.user.RealName;
        break;
        case 'password':
          $scope.userPage = $scope.editPasswordPage;
        break;
        case 'options':
          $scope.userPage = $scope.editOptionsPage;
        break;
        case 'phone':
          $scope.userPage = $scope.editPhonePage;
        break;
        case 'newUser':
          $scope.showNewUser = true;
          activeMenuButton({target: '#new-user-li'});
          $scope.currentUser = 'NEWUSER';
          $scope.userPage = $scope.newUserPage;
        break;
        case 'newUserSuccessfully':
          $scope.userPage = $scope.newUserSuccessfullyPage;
        break;
        case 'multi-factor-auth':
          $scope.userPage = $scope.multi_factor_auth;
          $scope.checkMfa();
        break;
        default:
          $scope.userPage = $scope.informationPage;
        break;
      }
    };
    $scope.isCurrentUser = function(user){
      return user === $scope.currentUser;
    };
    $scope.cancel = function(){
      $scope.showNewUser = false;
      $scope.currentUser = $window.sessionStorage.userName;
      $scope.newRealName = '';
      $scope.newUser = {};
      $scope.data = {};
      $scope.users = $scope.originalsUsers;
      $scope.changeUserPage($scope.informationPage);
      $scope.showPasswordRequired = false;
      $scope.showPasswordRequired2 = false;
      $scope.sortUserList();
      $scope.errorMessage = '';
    };
    $scope.closeModal = function(){
      $mdDialog.hide();
    };
    $scope.resetPasswd = function(){
      SecurityService.changePasswordByAdmin($scope.user.Username).then(function(){
        $scope.closeModal();
      }, function(error){
        /* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
        $scope.errorMessage = (error.data.error.frontend_message || undefined);
      });
    };
    $scope.updatePassword = function(form){
      if(form.$valid){
        if($scope.validation()){
          SecurityService.changePassword($scope.user.password).then(function(data){
            if(data.result.value){
              $scope.changeUserPage($scope.informationPage);
            }
            else{
              $scope.errorMessage = PASSWORD_MESSAGES.PASSWORD_CHANGED_FAILED;
            }
          }, function(error){
            /* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
            $scope.errorMessage = (error.data.error.frontend_message || undefined);
          });
        }
      }
      else{
        $scope.eventShowPasswordRequired();
      }
    };
    $scope.validation = function(){
      var passwordValidation = UtilsService.validatePassword(
        $scope.user.password,
        $scope.user.password2);
      if(!passwordValidation.value){
        $scope.errorMessage = passwordValidation.msg;
        return false;
      }
      else{
        $scope.errorMessage = '';
        return true;
      }
    };
    $scope.eventShowPasswordRequired = function(field){
      if(field == 'password1' || !field) {
        $scope.showPasswordRequired = true;
      }
      else{
        if(field == 'password2' || !field) {
          $scope.showPasswordRequired2 = true;
        }
      }
      $scope.errorMessage = '';
    };
    $scope.addNewUser = function(newUserForm){
      if(newUserForm.$valid && $scope.data.profile){
        var realName = $scope.newUser.firstName + ' ' + $scope.newUser.lastName;
        UserService.addNewUser($scope.newUser.email, realName, $scope.data.profile).then(function(){
          $scope.changeUserPage('newUserSuccessfully');
        }, function(error){
          /* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
          $scope.errorMessage = (error.data.error.frontend_message || undefined);
        });
      }
      else{
        if(newUserForm.email.$error.email){
          $scope.errorMessage = EMAIL_MESSAGES.EMAILFORMAT;
        }
        else{
          if(!$scope.data.profile){
            $scope.errorMessage = USERTYPE.REQUIRED;
          }
          else{
            $scope.eventShowFirstNameRequiered();
            $scope.eventShowLastNameRequiered();
            $scope.eventShowEmailRequiered();
          }
        }
      }
    };
    $scope.eventShowFirstNameRequiered = function(){
      $scope.errorMessage = '';
      $scope.showFirstNameRequiered = true;
    };
    $scope.eventShowLastNameRequiered = function(){
      $scope.errorMessage = '';
      $scope.showLastNameRequiered = true;
    };
    $scope.eventShowEmailRequiered = function(){
      $scope.errorMessage = '';
      $scope.showEmailRequiered = true;
    };
    $scope.getProfile = function(user){
      return UserService.setProfile(user.Profiles);
    };
    $scope.changeUserPage();
  }
]);
